import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Timestamp } from '@angular/fire/firestore';

const TABLE = "metrics";

@Injectable({
  providedIn: 'root'
})
export class MetricsService {

  constructor(private fireStore: AngularFirestore) {}

  logEvent(
    placeId: string,
    placeName: string,
    category: string,
    eventType: 'visit' | 'open_location' | 'open_website' | 'open_instagram' | 'contact_click' | 'download_free' | 'purchase_click', 
    userId?: string | null,
    source?: string | null
  ): void {
    const eventId = this.fireStore.createId();
    const eventRef: AngularFirestoreDocument<any> = this.fireStore.doc(`${TABLE}/${eventId}`);

    const eventData = {
      eventId: eventId,
      placeId: placeId,
      placeName: placeName,
      category: category,
      eventType: eventType,
      timestamp: Timestamp.now(),
      userId: userId || null,
      source,
    };

    eventRef.set(eventData, { merge: true })
      .then(() => {
        console.log('Metric event logged successfully:', eventData);
      })
      .catch((error) => {
        console.error('Error logging metric event:', error);
      });
  }
}
